import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import { Table, Column, Button, Pager } from '@smartplatform/ui';
import store from '../../store';

const PER_PAGE = 20;

@observer
export default class List extends React.Component {

	@observable records = null;
	@observable page = 1;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.records = await store.model.Itogi.find({
			order: 'id desc',
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
		});
	};
	
	onPageChange = async page => {
		this.page = page;
		this.init();
	};

	create = () => this.props.history.push('/admin/itogi/create');

	render() {
		if (!this.records) return '...';

		return <>
			<p>Статичные страницы</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			<Pager totalCount={this.records.totalCount} current={this.page} itemsPerPage={PER_PAGE} onChange={this.onPageChange} />
			<Table records={this.records} rootPath="/admin" path="itogi">
				<Column property="title" label="Заголовок" />
				<Column property="route" label="Путь" />
				<Column property="text" label="Текст" />
			</Table>
		</>;
	}

}
